import React from "react";
import { Link } from "react-router-dom";
import { Footer } from "../Footer";
import firstfellowpartnersWhitePng1 from "../../assets/images/first-fellow-partners-white.png";
import StaggeredMenu from "../ui/StaggeredMenu";
import { SEOHead } from "../SEOHead";
import mikiKuusiImage from "../../assets/images/people/1714215017133.jpeg";
import jaakkoKokkoImage from "../../assets/images/people/jaako kokko.jpeg";
import pekkaRantalaImage from "../../assets/images/people/1517381317277.jpeg";
import timoSoininenImage from "../../assets/images/people/timo-soininen-headshot_320.jpeg";

export const ReferencesPage = () => {
  const menuItems = [
    { label: 'Our Manifesto', ariaLabel: 'View our manifesto', link: '/manifesto' },
    { label: 'Family Members', ariaLabel: 'View family members', link: '/family' },
    { label: 'Team', ariaLabel: 'Meet our team', link: '/team' },
    { label: 'References', ariaLabel: 'View references', link: '/references' },
    { label: 'Get in touch', ariaLabel: 'Get in touch with us', link: '/contact' }
  ];

  const socialItems = [
    { label: 'Twitter', link: 'https://twitter.com' },
    { label: 'LinkedIn', link: 'https://linkedin.com' }
  ];

  const referenceItems = [
    {
      image: mikiKuusiImage,
      link: 'https://fi.linkedin.com/in/mikikuusi',
      name: 'Miki Kuusi',
      role: 'co-founder & CEO Wolt',
      quote: 'FFP was one of the first believers in our team when there were very few people who believed in what we\'d set out to build. During good times it\'s really easy to be a good investor; it\'s during the bad times that you really distinguish the good from the great.'
    },
    {
      image: pekkaRantalaImage,
      link: 'https://fi.linkedin.com/in/pekka-rantala-65618b61',
      name: 'Pekka Rantala',
      role: 'CEO ePassi',
      quote: 'Throughout our journey together until their successful exit in 2023, they were a highly supportive and engaged partner, contributing meaningfully to Epassi\'s strong growth story.'
    },
    {
      image: jaakkoKokkoImage,
      link: 'https://www.linkedin.com/in/jkokko',
      name: 'Jaakko Kokko',
      role: 'co-founder & CEO Alphasense',
      quote: 'Exceptionally impactful and founder-friendly investor that\'s always there when you need advice or intros - highly recommended.'
    },
    {
      image: timoSoininenImage,
      link: 'https://ch.linkedin.com/in/timosoininen',
      name: 'Timo Soininen',
      role: 'co-founder & CEO Small Giant Games',
      quote: 'Every founder needs a partner like FFP — thoughtful, supportive, and in it for the long run.'
    }
  ];

  return (
    <div className="bg-[#121212] w-full min-h-screen overflow-y-auto scrollbar-default flex flex-col">
      <SEOHead
        title="References | First Fellow Partners"
        description="Hear from founders we've backed — Miki Kuusi (Wolt), Jaakko Kokko (Alphasense), Timo Soininen (Small Giant Games) and others share their experience partnering with FFP."
        path="/references"
      />
      {/* Navbar */}
      <div className="w-full bg-[#121212] border-b border-[#424242] z-50">
        <div className="flex justify-between items-center px-4 sm:px-6 lg:px-10 py-2 sm:py-4 gap-4">
          {/* Logo on the left */}
          <Link to="/" className="w-[80px] h-[80px] sm:w-[100px] sm:h-[100px] lg:w-[140px] lg:h-[140px]">
            <img
              className="w-full h-full object-contain"
              alt="First Fellow Partners logo"
              src={firstfellowpartnersWhitePng1}
            />
          </Link>

          {/* StaggeredMenu button on the right */}
          <div className="w-[60px] h-[60px] sm:w-[80px] sm:h-[80px] lg:w-[120px] lg:h-[120px] flex items-center justify-end">
            <StaggeredMenu
              position="right"
              items={menuItems}
              socialItems={socialItems}
              displaySocials={true}
              displayItemNumbering={true}
              menuButtonColor="#fff"
              openMenuButtonColor="#000"
              changeMenuColorOnOpen={true}
              colors={['#1a1a1a', '#424242']}
              logoUrl=""
              accentColor="#000"
              isFixed={true}
              onMenuOpen={() => console.log('Menu opened')}
              onMenuClose={() => console.log('Menu closed')}
            />
          </div>
        </div>
      </div>

      {/* Main Content Area */}
      <div className="flex-1 w-full py-12 px-4 sm:px-6 lg:px-10">
        <div className="max-w-7xl mx-auto space-y-16 sm:space-y-20">
          {referenceItems.map((reference, index) => (
            <div
              key={index}
              className="flex flex-col md:flex-row items-start md:items-center gap-8 md:gap-12"
            >
              {/* Image on the left */}
              <div className="flex-shrink-0 w-full md:w-auto">
                <a
                  href={reference.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block"
                >
                  <img
                    src={reference.image}
                    alt={reference.name}
                    className="w-full md:w-64 h-64 object-cover rounded-lg"
                  />
                </a>
              </div>

              {/* Quote and person info on the right */}
              <div className="flex-1 flex flex-col justify-center">
                <blockquote className="text-white text-lg sm:text-xl md:text-2xl font-light leading-relaxed mb-6">
                  "{reference.quote}"
                </blockquote>
                <div className="flex items-center gap-2">
                  <a
                    href={reference.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white hover:opacity-80 transition-opacity"
                  >
                    <span className="font-semibold text-base sm:text-lg">{reference.name}</span>
                    <span className="text-gray-400 text-sm sm:text-base ml-2">{reference.role}</span>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Footer */}
      <div className="w-full mt-auto">
        <Footer />
      </div>
    </div>
  );
};

